import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { ColorsService } from './colors/colors.service';
import { FiltroPipe } from "../pipes/filtro.pipe";
import { FiltronumericoPipe } from "../pipes/filtronumerico.pipe";
import { LinhaPipe } from "../pipes/linha.pipe";
import { LinhaOcultaPipe } from '../pipes/linha-oculta.pipe';
import { PrecoVendaPipe } from '../pipes/preco-venda.pipe';
import { SortbyPipe } from '../pipes/sortby.pipe';
import { ThousandsFormatPipe } from "../pipes/thousands-format.pipe";
import { BrNumberPipe } from '../pipes/br-number.pipe';
import { CustomMultiSelectComponent } from './components/custom-multi-select/custom-multi-select.component';

// https://angular.io/styleguide#!#04-10
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,
        CarouselModule,
        CollapseModule,
        BsDatepickerModule,
        BsDropdownModule,
        ModalModule,
        PaginationModule,
        ProgressbarModule,
        RatingModule,
        TabsModule,
        TimepickerModule,
        TooltipModule,
        PopoverModule,
        TypeaheadModule
    ],
    providers: [
        ColorsService
    ],
    declarations: [
        FiltroPipe,
        FiltronumericoPipe,
        LinhaPipe,
        LinhaOcultaPipe,
        ThousandsFormatPipe,
        PrecoVendaPipe,
        SortbyPipe,
        BrNumberPipe,
        CustomMultiSelectComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,
        CarouselModule,
        CollapseModule,
        BsDatepickerModule,
        BsDropdownModule,
        ModalModule,
        PaginationModule,
        ProgressbarModule,
        RatingModule,
        TabsModule,
        TimepickerModule,
        TooltipModule,
        PopoverModule,
        TypeaheadModule,
        FiltroPipe,
        FiltronumericoPipe,
        LinhaPipe,
        LinhaOcultaPipe,
        ThousandsFormatPipe,
        PrecoVendaPipe,
        SortbyPipe,
        BrNumberPipe,
        CustomMultiSelectComponent
    ]
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule
        };
    }
}
